import React, { useEffect, useState } from 'react'
import DebtInformationListView from './components/DebtInformationListView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const DebtInformationList = ({ i18n }) => {
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        try {
            addToGoogleDataLayer('debt-information-list', 'Pay a Debt', i18n.language)
            window.scrollTo(0, 0)
        } catch (e) {
            console.log(e)
        }
    }, [i18n.language])

    return isError ? <Error /> : <DebtInformationListView setIsError={setIsError} />
}

export default withTranslation('common')(DebtInformationList)
